module.exports = __webpack_public_path__ + "fonts/CrimsonText-SemiBoldItalic.03046b72.eot";